// extracted by mini-css-extract-plugin
export default {"wrapper":"Avatar_wrapper__0iNQZ","img":"Avatar_img__1reZ+","sm":"Avatar_sm__s1Q-O","md":"Avatar_md__FZLJT","lg":"Avatar_lg__ydA0q","onlineDot":"Avatar_onlineDot__Z7f8O"};